import { ChangeEvent, FC, useState, useEffect } from 'react';
import { useStore } from 'hooks/useRootStore';
import { useMutation } from 'react-query';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { InvitationFormProps } from './types';
import { useStyles } from './styles';
import CloseIcon from '@material-ui/icons/Close';
import { Grid, Modal, Paper, IconButton, Tabs, Tab } from '@material-ui/core';
import TabPanel from 'components/TabPanel';
import { Manually } from './TabsContent/Manually';
import { CsvFile } from './TabsContent/CSV';
import { Groups } from './TabsContent/Groups';
import { Department } from './TabsContent/Departments';
import { Alluser } from './TabsContent/Allusers';
import { dataPath } from './Data';
// import { useQuery } from 'react-query';

export const InvitationNewPassword: FC<InvitationFormProps> = ({ open, refetch, handleClose, emailtemps }) => {
  const classes = useStyles();
  const [selectedTab, setSelectedTab] = useState<any>({
    one: true,
    second: false,
    third: false,
    fourth: false,
    fifth: false,
  });
  const {
    invitationStore: { sendInvitation },
    notificationStore: { openNotification },
    ldapStore: { usersView },
  } = useStore();
  const [value, setValue] = useState('one');
  const [isAuthenticated, setIsAuthenticated] = useState(true);

  useEffect(() => {
    if (open) {
      setIsAuthenticated(true);
      setSelectedTab({ one: true, second: false, third: false, fourth: false, fifth: false });
      setValue('one');
    }
  }, [open]);

  const [stepValue, setStepValue] = useState();
  const sendInvitationReq = useMutation((data: unknown) => sendInvitation(data), {
    mutationKey: 'sendInvitationReq',
    onSuccess: (e) => {
      openNotification('success', `${e}`);
      handleClose();
    },
    onError: (e) => openNotification('error', `${e}`),
  });
  useAppPreloader(sendInvitationReq.isLoading);
  function a11yProps(index: string) {
    return {
      id: `wrapped-tab-${index}`,
      'aria-controls': `wrapped-tabpanel-${index}`,
    };
  }

  const handleChange = (event: ChangeEvent<unknown>, newValue: string) => {
    setValue(newValue);
  };

  const handleemail = () => {
    setIsAuthenticated(true);
  };

  const svgChangger: any = (value: number) => {
    return (
      <svg width='20' height='14' viewBox='0 0 12 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
        {dataPath[value - 1].pathD.map((i, index) => (
          <path key={index} d={i} fill={Object.values(selectedTab)[value - 1] ? '#FFFFFF' : 'grey'} fillOpacity='1' />
        ))}
      </svg>
    );
  };
  return (
    <Modal className={classes.modal} disablePortal disableEnforceFocus disableAutoFocus open={open}>
      <Paper className={`${classes.paper}`} elevation={3}>
        <Grid container className={classes.topbar}>
          <Grid item xs={10}>
            {value === 'one' && stepValue === true && (
              <p className={classes.label}>Send Invites to one or more comma separated email addresses</p>
            )}
            {value === 'two' && stepValue === true && (
              <p className={classes.label}>Select one or more Groups to send invitation email</p>
            )}
            {value === 'three' && stepValue === true && (
              <p className={classes.label}>Select one or more Departments to send invitation email</p>
            )}
            {value === 'four' && stepValue === true && (
              <p className={classes.label}>Upload a CSV File containing email addresses</p>
            )}
            {value === 'five' && stepValue === true && (
              <p className={classes.label}>Send invite to All Users in EasyIdentity</p>
            )}
          </Grid>
          <Grid item xs={2} className={classes.closeIcon}>
            <IconButton
              style={{ marginRight: -16 }}
              onClick={() => {
                setIsAuthenticated(true);
                handleClose();
              }}
            >
              <CloseIcon className={classes.closebtn} />
            </IconButton>
          </Grid>
        </Grid>

        <Grid
          className={isAuthenticated === false ? `${classes.rowf}` : `${classes.row}`}
          container
          justify='space-between'
        >
          <Grid item xl className={classes.tabsPanel}>
            <Paper className={classes.tabsPaper}>
              {isAuthenticated === true && (
                <Tabs
                  value={value}
                  className={classes.tabs}
                  TabIndicatorProps={{ style: { color: 'transparent', background: 'transparent' } }}
                  onChange={handleChange}
                >
                  <Tab
                    value='one'
                    label={
                      <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                        <div>{svgChangger(1)}</div>
                        <div>Manual</div>
                      </div>
                    }
                    wrapped
                    onClick={() =>
                      setSelectedTab({ one: true, second: false, third: false, fourth: false, fifth: false })
                    }
                    {...a11yProps('one')}
                    className={classes.tablabel}
                  ></Tab>

                  <Tab
                    value='two'
                    wrapped
                    label={
                      <div style={{ display: 'flex', flexDirection: 'row', gap: '6px' }}>
                        <div>{svgChangger(2)}</div>
                        Groups
                      </div>
                    }
                    onClick={() =>
                      setSelectedTab({ one: false, second: true, third: false, fourth: false, fifth: false })
                    }
                    {...a11yProps('two')}
                    className={classes.tablabel}
                  />
                  <Tab
                    value='three'
                    wrapped
                    label={
                      <div style={{ display: 'flex', flexDirection: 'row', gap: '6px' }}>
                        <div>{svgChangger(3)}</div>
                        Departments
                      </div>
                    }
                    onClick={() =>
                      setSelectedTab({ one: false, second: false, third: true, fourth: false, fifth: false })
                    }
                    {...a11yProps('three')}
                    className={classes.tablabel}
                  />
                  <Tab
                    value='four'
                    wrapped
                    label={
                      <div style={{ display: 'flex', flexDirection: 'row', gap: '6px' }}>
                        <div>{svgChangger(4)}</div>
                        Upload CSV
                      </div>
                    }
                    {...a11yProps('four')}
                    className={classes.tablabel}
                    onClick={() =>
                      setSelectedTab({ one: false, second: false, third: false, fourth: true, fifth: false })
                    }
                  />
                  <Tab
                    value='five'
                    wrapped
                    label={
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          gap: '8px',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'end',
                            alignItems: 'flex-start',
                            height: '10px',
                            width: '20px',
                          }}
                        >
                          {svgChangger(5)}
                        </div>
                        <div> All users</div>
                      </div>
                    }
                    onClick={() =>
                      usersView.length > 0 &&
                      setSelectedTab({ one: false, second: false, third: false, fourth: false, fifth: true })
                    }
                    {...a11yProps('five')}
                    className={classes.tablabel}
                    disabled={usersView.length === 0}
                  />
                </Tabs>
              )}

              <div className={classes.tabBox}>
                <TabPanel value={value} index='one'>
                  <Manually
                    handleClose={handleClose}
                    refetch={refetch}
                    open={open}
                    emailtemps={handleemail}
                    step={setStepValue}
                  />
                </TabPanel>
                <TabPanel value={value} index='two'>
                  <Groups
                    handleClose={handleClose}
                    refetch={refetch}
                    open={open}
                    emailtemps={handleemail}
                    step={setStepValue}
                  />
                </TabPanel>
                <TabPanel value={value} index='three'>
                  <Department
                    handleClose={handleClose}
                    refetch={refetch}
                    open={open}
                    emailtemps={handleemail}
                    step={setStepValue}
                  />
                </TabPanel>
                <TabPanel value={value} index='four'>
                  <CsvFile
                    handleClose={handleClose}
                    refetch={refetch}
                    open={open}
                    emailtemps={handleemail}
                    step={setStepValue}
                  />
                </TabPanel>
                <TabPanel value={value} index='five'>
                  <Alluser
                    handleClose={handleClose}
                    refetch={refetch}
                    open={open}
                    emailtemps={handleemail}
                    step={setStepValue}
                  />
                </TabPanel>
              </div>
            </Paper>
          </Grid>
        </Grid>
        <Grid></Grid>
      </Paper>
    </Modal>
  );
};
